<ng-container
  *appLet="{
    culture: culture$ | async,
  } as $comp"
>
  @if (errors && control.errors && doShowAnyErrors) {
    <div class="mt-1">
      @for (errorKeyValue of errors | keyvalue; track $index) {
        <ng-container
          *appLet="control.errors[errorKeyValue.key] as controlErrorValue"
        >
          @if (hasError(errorKeyValue.key)) {
            @if (isString(errorKeyValue.value)) {
              <div class="form-error">
                {{
                  errorKeyValue.value
                    | interpolate: [controlErrorValue] : $comp.culture
                }}
              </div>
            }
            @if (isObject(errorKeyValue.value)) {
              @for (
                errorPropertyKeyValue of errorKeyValue.value | keyvalue;
                track $index
              ) {
                @if (
                  controlErrorValue &&
                  controlErrorValue[errorPropertyKeyValue.key]
                ) {
                  <div class="form-error">
                    {{
                      errorPropertyKeyValue.value
                        | interpolate
                          : [controlErrorValue[errorPropertyKeyValue.key]]
                          : $comp.culture
                    }}
                  </div>
                }
              }
            }
          }
        </ng-container>
      }
    </div>
    @for (errorPair of extraErrors | keyvalue; track $index) {
      @if (control.hasError(errorPair.key)) {
        <div class="form-error">
          {{ errorPair.value }}
        </div>
      }
    }
  }
</ng-container>
